module.exports = __webpack_public_path__ + "media/images/arrow-537d5e82.png";